export default __webpack_public_path__ + "static/media/cupcake-5.b37037e3.jpg";